import React, { createContext, useState } from "react"

export type AuthUser = {
    name : string
    email : string
}

type UserContextProviderProps = {
    children  : React.ReactNode
}

// type UserContextType = {
//     user : AuthUser | null
//     setUser : React.Dispatch<React.SetStateAction<AuthUser | null>>
// }

type isAuthorizedContextType = {
    isaAuthorized : boolean 
    setIsaAuthorized : React.Dispatch<React.SetStateAction<boolean>>
}


// export const UserContext = createContext({} as UserContextType)
export const IsAuthorizedContext = createContext({} as isAuthorizedContextType)
// export const UserContext = createContext<UserContextType | null>(null)

export const IsAuthorizedContextProvider =  
({children} : UserContextProviderProps) => {
  
    // const [user, setUser] = useState<AuthUser | null>(null)  // this technique is called as Union type
console.log('---IsAuthorizedContext ApI initialization----');

    let item =  localStorage.getItem('isAuthorized');
    let boolval =  false;
    if(item === 'true'){
        boolval = true;
    }



    const [isaAuthorized, setIsaAuthorized ] = useState<boolean>(boolval);
    
    return (
    <IsAuthorizedContext.Provider value={{isaAuthorized, setIsaAuthorized}}>
          {children} 
    </IsAuthorizedContext.Provider>
    )
    

}

